import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; 

const ProtectedRoute = () => {
    const token = localStorage.getItem("access_token");

    if (!token) {
        return <Navigate to="/" />;
    }

    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Convertir a segundos

        if (decodedToken.exp < currentTime) {
            // Token expirado, redirigir a login
            localStorage.removeItem("access_token");
            return <Navigate to="/" />;
        }

        return <Outlet />; // Renderiza la ruta protegida si el token es válido
    } catch (error) {
        console.error("Error al decodificar el token:", error);
        localStorage.removeItem("access_token");
        return <Navigate to="/" />;
    }
};

export default ProtectedRoute;
